import React, { Component } from 'react';
import ResearchField from './ResearchField.js'
import ChevronDown from "./images/ChevronDown";

class Research extends Component {
    
    state = {
        'expandLabel': 'See More',
        'curChevronStyle': chevronStyle
    }

    constructor(props) {
        super(props);
        this.fieldElement = React.createRef();
    }
    
    render() {

        const expandResearch = () => {
            this.fieldElement.current.expand();
            if (this.state.expandLabel === 'See More') {
                this.setState({expandLabel: 'Collapse', curChevronStyle: chevronReverseStyle});
            } else {
                this.setState({expandLabel: 'See More', curChevronStyle: chevronStyle});
            }
        }

        return (
            <div style={researchStyle}>
                <div style={researchHeaderContainerStyle}>
                    <h1 style={researchHeaderStyle}>Research</h1>  
                    <ResearchField research={this.props.research} ref={this.fieldElement} />
                    <a style={expandStyle} onClick={expandResearch}>    
                        
                        {this.state.expandLabel}

                        <ChevronDown fill={'#777'} style={this.state.curChevronStyle} />
                    </a>
                </div>
            </div>
        );
    }
}

const researchStyle = {
    height: 'auto',
    width: '1100px',
    background: 'white',
    color: '#000',
    margin: 'auto',
    padding: '0px 100px 30px 100px',
    display: 'flex',
    flexWrap: 'wrap',
    textAlign: 'center',
}

const researchHeaderContainerStyle = {
    margin: '30px auto'
}

const researchHeaderStyle = {
    fontFamily: 'Lora, serif',
    fontSize: '40px',
    margin: '20px auto'
}

const expandStyle = {
    fontSize: '24px',
    marginLeft: '180px'
}

const chevronStyle = {
    width: '20px',
    height: '20px',
    margin: '0px 0px 0px 8px',
    transform: 'rotate(0deg)'
}

const chevronReverseStyle = {
    width: '20px',
    height: '20px',
    margin: '0px 0px 0px 8px',
    transform: 'rotate(180deg)'
}

export default Research;